import { ReactNode } from "react"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import type { ServiceCenterBookingOrganizer } from "../../serviceCenterHomeTypes"

const useStyles = makeStyles()(() => ({
    userDialog: {
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: ".5rem",
        rowGap: ".5rem",
        alignItems: "start",
        padding: "1rem 2rem 2rem",
    },
    userDialogLabel: {
        color: tailwindPalette.slate[500],
    },
}))

type Props = Readonly<{
    isOpen: boolean
    host: Omit<ServiceCenterBookingOrganizer, "type"> | null
    onClose: () => void
    dialogTitle?: ReactNode
}>

export function HostContactDetailsDialog({ isOpen, host, onClose, dialogTitle }: Props) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={isOpen}
            onClose={onClose}
            maxWidthProp="sm"
            dialogTitle={
                dialogTitle ?? (
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-title">
                        <>Host contact details</>
                    </LocalizedStrict>
                )
            }
        >
            <Box className={classes.userDialog}>
                {host?.name && (
                    <>
                        <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-name">
                            <Typography className={classes.userDialogLabel}>Name:</Typography>
                        </LocalizedStrict>
                        <Typography>{host.name}</Typography>
                    </>
                )}
                {host?.company?.name && (
                    <>
                        <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name">
                            <Typography className={classes.userDialogLabel}>Company:</Typography>
                        </LocalizedStrict>
                        <Typography>{host.company.name}</Typography>
                    </>
                )}
                {host?.department?.name && (
                    <>
                        <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name">
                            <Typography className={classes.userDialogLabel}>Department:</Typography>
                        </LocalizedStrict>
                        <Typography>{host.department.name}</Typography>
                    </>
                )}
                {host?.email && (
                    <>
                        <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-email">
                            <Typography className={classes.userDialogLabel}>E-mail:</Typography>
                        </LocalizedStrict>
                        <Typography>{host.email}</Typography>
                    </>
                )}
                {(host?.phone || host?.businessPhone) && (
                    <>
                        <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone">
                            <Typography className={classes.userDialogLabel}>Phone number:</Typography>
                        </LocalizedStrict>
                        <Typography>{host?.phone || host?.businessPhone}</Typography>
                    </>
                )}
                {host?.mobilePhone && (
                    <>
                        <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone">
                            <Typography className={classes.userDialogLabel}>Mobile number:</Typography>
                        </LocalizedStrict>
                        <Typography>{host.mobilePhone}</Typography>
                    </>
                )}
            </Box>
        </StandardDialog>
    )
}
